var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 15H4.5C3.65625 15 3 15.7031 3 16.5V22.5C3 23.3438 3.65625 24 4.5 24H19.5C20.2969 24 21 23.3438 21 22.5V16.5C21 15.7031 20.2969 15 19.5 15ZM19.5 22.5H4.5V16.5H19.5V22.5ZM21 9V3.32812C21 2.95312 20.8125 2.53125 20.5312 2.25L18.7031 0.46875C18.4219 0.1875 18.0469 0 17.6719 0H6C4.3125 0 3 1.35938 3 3V9C1.3125 9 0 10.3594 0 12V17.25C0 17.6719 0.328125 18 0.75 18C1.125 18 1.5 17.6719 1.5 17.25V12C1.5 11.2031 2.15625 10.5 3 10.5H21C21.7969 10.5 22.5 11.2031 22.5 12V17.25C22.5 17.6719 22.8281 18 23.25 18C23.625 18 24 17.6719 24 17.25V12C24 10.3594 22.6406 9 21 9ZM19.5 9H4.5V3C4.5 2.20312 5.15625 1.5 6 1.5H17.6719L19.5 3.32812V9ZM20.25 11.625C19.5938 11.625 19.125 12.1406 19.125 12.75C19.125 13.4062 19.5938 13.875 20.25 13.875C20.8594 13.875 21.375 13.4062 21.375 12.75C21.375 12.1406 20.8594 11.625 20.25 11.625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIcon);
export default __webpack_public_path__ + "static/media/print-icon.d9a374b60db9f42554fc89482179803c.svg";
export { ForwardRef as ReactComponent };